<template>
  <div style="display: inline-block; vertical-align: top">
    <el-image v-if="tag == 'el-image'" :src="`${formatSrc}?t=${FileToken}&thumbnail=${thumbnail}`" :fit="fit" :preview-src-list="thumbnail ? [] : authPreviewSrcList" @click="clickHandler">
      <div slot="error" class="image-slot">
        {{ formatSrc ? '加载失败' : '无图片' }}
      </div>
    </el-image>
    <video v-else-if="tag == 'video'" :src="`${formatSrc}?t=${FileToken}`"></video>
    <img v-else :src="`${formatSrc}?t=${FileToken}`" alt="" />
    <image-viewer :z-index="2000" :initial-index="imageIndex" v-if="showViewer" :on-close="closeViewer" :url-list="authPreviewSrcList" />
  </div>
</template>

<script>
import ImageViewer from 'element-ui/packages/image/src/image-viewer.vue'

let prevOverflow = ''

export default {
  components: {
    ImageViewer,
  },
  data() {
    return {
      imageIndex: 0,
      showViewer: false,
    }
  },
  props: {
    src: String,
    tag: String,
    fit: String,
    thumbnail: {
      type: Boolean,
      default: false,
    },
    previewSrcList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    authPreviewSrcList() {
      return this.previewSrcList.map((item) => {
        return `${item.replaceAll('#', 'hashtag')}?t=${this.FileToken}`
      })
    },
    formatSrc() {
      return this.src.replaceAll('#', 'hashtag')
    },
  },
  methods: {
    closeViewer() {
      document.body.style.overflow = prevOverflow
      this.showViewer = false
    },

    clickHandler() {
      if (!this.thumbnail) {
        return
      }

      this.imageIndex = this.previewSrcList.indexOf(this.formatSrc)

      // prevent body scroll
      prevOverflow = document.body.style.overflow
      document.body.style.overflow = 'hidden'
      this.showViewer = true
    },
  },
}
</script>
